import './PrivacyPolicy.scss';
import { useNavigate } from 'react-router-dom';
import { Smartphone, Briefcase, Target, UserCheck, ChevronRight } from 'lucide-react';

const documents = [
    {
        type: 'app',
        document: 'policy',
        kind: 'Privacy',
        surfaceName: 'Mobile App',
        surfaceSubtitle: 'iOS & Android',
        icon: Smartphone,
    },
    {
        type: 'business',
        document: 'policy',
        kind: 'Privacy',
        surfaceName: 'Business Panel',
        surfaceSubtitle: 'business.zona.miami',
        icon: Briefcase,
    },
    {
        type: 'advertiser',
        document: 'policy',
        kind: 'Privacy',
        surfaceName: 'Ads Portal',
        surfaceSubtitle: 'getzona.app/ads',
        icon: Target,
    },
    {
        type: 'promoter',
        document: 'policy',
        kind: 'Privacy',
        surfaceName: 'Affiliate Portal',
        surfaceSubtitle: 'getzona.app/affiliates',
        icon: UserCheck,
    },
];

function PrivacyPolicy() {
    const navigate = useNavigate();

    return (
        <section className='legal-list'>
            <header className='legal-list__header'>
                <h2>Privacy Policy</h2>
                <p>Select a surface to edit its policy.</p>
            </header>

            <ul className='legal-list__items'>
                {documents.map((d) => {
                    const Icon = d.icon;
                    return (
                        <li key={`${d.type}-${d.document}`}>
                            <button
                                type='button'
                                className='legal-list__item'
                                onClick={() => navigate(`/legal/${d.type}/${d.document}`)}
                            >
                                <span className='legal-list__item-icon'>
                                    <Icon size={18} />
                                </span>
                                <span className='legal-list__item-text'>
                                    <span className='legal-list__item-title'>
                                        {d.surfaceName}
                                    </span>
                                    <span className='legal-list__item-sub'>
                                        {d.kind} · {d.surfaceSubtitle}
                                    </span>
                                </span>
                                <ChevronRight size={18} className='legal-list__item-chevron' />
                            </button>
                        </li>
                    );
                })}
            </ul>
        </section>
    );
}

export default PrivacyPolicy;
